<div class="text-center" data-test-id="Partnership" *ngIf="canShow">
    {{"Login_In_Partnership_With" | translate}}
    <svg class="partnershipLogo ml-1 border-none"></svg>
</div>
